<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Support
      </content-page-title>
    </template>
    <div class="white pa-2 rounded">
      Click the link below to send our suport an email:
      <div class="py-2 text-center">
        <a href="mailto:support@partnerlists.com">support@partnerlists.com</a>
      </div>
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'

export default {
  name: 'SupportView',
  
  components: { 
    ContentPage,
    ContentPageTitle
  },

}
</script>
